// Modules
// =============================================================================

import $ from 'zepto';
import AdhView from 'adh-view.js';


// Class
// =============================================================================

export default class App {
  constructor() {
    new AdhView();
  }
}


// WEBPACK FOOTER //
// ./src/js/views/app.js